import React, { useEffect, useState } from "react";
import { Typography } from "../Typography";
import { StyledCheckbox, StyledCheckboxWrapper } from "./styles";
import { CheckboxProps } from "./types";
import { useBreakpoint } from "shared/hooks/useBreakpoint";
/**
 * Componente Checkbox
 *
 * Um campo de seleção customizado com suporte a label e callback para alterações.
 *
 * @param {string} name - Nome do grupo de checkboxes.
 * @param {number} value - Valor associado ao checkbox.
 * @param {boolean} isChecked - Indica se o checkbox está marcado.
 * @param {string} label - Texto exibido ao lado do checkbox.
 * @param {string} [color='darkGray'] - Cor do texto da label.
 * @param {(value: string) => void} onChange - Callback executado ao alterar o checkbox.
 */
export const Checkbox: React.FC<CheckboxProps> = ({
  name,
  value,
  isChecked,
  label,
  onChange,
  color = "darkGray",
}) => {
  const [isMobile, setMobile] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setMobile(breakpoint !== "xxl");
  }, [breakpoint]);

  return (
    <StyledCheckboxWrapper
      isMobile={isMobile}
      onClick={() => value && onChange(value.toString())}
    >
      <StyledCheckbox
        type="checkbox"
        name={name}
        value={value}
        checked={isChecked}
        readOnly
        aria-checked={isChecked}
      />
      <Typography color={color} variant="body">
        {label}
      </Typography>
    </StyledCheckboxWrapper>
  );
};
